export default "__VITE_ASSET__4U9BxGRz__"